// import { Theme, makeStyles } from '@material-ui/core/styles';
import { IllustrationColor } from 'ui/illustrations/Illustration';
import { Theme, css } from '@emotion/react';

const getColorTheme = (color: IllustrationColor, { colors, legacyColors }: Theme) => {
  switch (color) {
    case 'dark':
      return css`
        --illo-dots: ${legacyColors.legacyDecorative19};
        --illo-fills: ${colors.bgDarker};
        --illo-shadows: ${colors.bgDarker};
        --illo-strokes: ${colors.bgDarker};
      `;
    case 'primary':
      return css`
        --illo-dots: ${legacyColors.legacyDecorative19};
        --illo-fills: ${colors.bgPrimaryBase};
        --illo-shadows: ${colors.bgPrimaryBase};
        --illo-strokes: ${colors.bgPrimaryBase};
      `;
    case 'disabled':
      return css`
        --illo-dots: ${colors.fgDisabled};
        --illo-fills: ${colors.fgDisabled};
        --illo-shadows: ${colors.fgDisabled};
        --illo-strokes: ${colors.fgDisabled};
      `;
  }
};

export const illustrationRoot = (color: IllustrationColor) => (theme: Theme) => css`
    ${getColorTheme(color, theme)}

    fill: none;
    height: auto;
    width: 100%;
    & path, & rect, & circle, & ellipse {
      transition: all 200ms ease-in-out;
    }
    & .strokes {
      stroke-linecap: round;
      stroke-miter-limit: 10,
    },
    & g.dots {
      fill: var(--illo-dots);
    },
    & g.fills {
      fill: var(--illo-fills);
    },
    & g.shadows {
      fill: var(--illo-shadows);
      fill-opacity: var(--illo-shadows-opacity, 0.15);
    },
    & g.strokes {
      stroke: var(--illo-strokes);
    },
 `;
